/**
 * Returns the search parameter value given the name for it. Returns null if
 * the search parameter was not found in the current url.
 *
 * These can be passed in the url for the page like so:
 *
 * ```ts
 * // assuming url = 'http://localhost/?MY_VAR=5'
 * getSearchParam('MY_VAR') // returns 5
 * ```
 *
 * @param name the url search parameter name
 */
export function getSearchParam(name: string): string | null {
  // NOTE: allows for jest-environment node
  if (!globalThis.location?.href) {
    return null;
  }
  const currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get(name);
}

/**
 * Returns the value for a search parameter flag. Returns null if the search
 * paramter was not found in the current url.
 *
 * Returns true for 'true' and false for 'false' (case insensitive matching).
 *
 * @see getSearchParam
 */
export function getSearchParamFlag(name: string): boolean | null {
  const value = getSearchParam(name);
  switch (value?.toLowerCase()) {
    case undefined:
      return null;
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      console.warn(`Unexpected value for "${name}" search param flag: ${value}`);
      return null;
  }
}
